import "./PublicationEthics.scss";
import journalPolicies from './publicationEthicsData';

const PublicationEthics = () => {
    return (
        <section className="publicationEthicsMainContainer">
            <article className="contentParent">
                {journalPolicies.map((policy, index) => (
                    policy.points.length <= 1 && policy.bulletPoints === false ?
                        (
                            <p style={{ width: "fit-content" }}> <strong>{policy.category}</strong> {policy.points}</p>
                        ) :
                        (
                            <div key={index} style={{ display: "flex", flexDirection: "column" }}>
                                <h3>{policy.category}</h3>
                                <ul>
                                    {policy.points.map((point, index) => (
                                        <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                                    ))}
                                </ul>
                            </div>
                        )
                ))}
            </article>
        </section >
    )
}

export default PublicationEthics
